module.exports = __webpack_public_path__ + "img/OK MART.fd271662.svg";